import {
  EXPORT_ROOM_BOOKING_FAILURE,
  EXPORT_ROOM_BOOKING_REQUEST,
  EXPORT_ROOM_BOOKING_SUCCESS,
  GET_ALL_BOOKING_LOGS_FAILURE,
  GET_ALL_BOOKING_LOGS_REQUEST,
  GET_ALL_BOOKING_LOGS_SUCCESS,
  GET_ALL_RESERVATION_LIST_FAILURE,
  GET_ALL_RESERVATION_LIST_REQUEST,
  GET_ALL_RESERVATION_LIST_SUCCESS,
  GET_BYID_ROOM_BOOKING_FAILURE,
  GET_BYID_ROOM_BOOKING_REQUEST,
  GET_BYID_ROOM_BOOKING_SUCCESS,
  GET_RESERVATION_LIST_EXPORT_FAILURE,
  GET_RESERVATION_LIST_EXPORT_REQUEST,
  GET_RESERVATION_LIST_EXPORT_SUCCESS,
  GET_ROOM_BOOKING_LIST_FAILURE,
  GET_ROOM_BOOKING_LIST_REQUEST,
  GET_ROOM_BOOKING_LIST_SUCCESS,
  PATCH_ROOM_BOOKING_FAILURE,
  PATCH_ROOM_BOOKING_REQUEST,
  PATCH_ROOM_BOOKING_SUCCESS,
  POST_RECORD_PAYMENT_FAILURE,
  POST_RECORD_PAYMENT_REQUEST,
  POST_RECORD_PAYMENT_SUCCESS,
  POST_ROOM_BOOKING_FAILURE,
  POST_ROOM_BOOKING_REQUEST,
  POST_ROOM_BOOKING_SUCCESS,
  PUT_ROOM_BOOKING_DETAILS_FAILURE,
  PUT_ROOM_BOOKING_DETAILS_REQUEST,
  PUT_ROOM_BOOKING_DETAILS_SUCCESS,
  PUT_ROOM_REASSIGN_FAILURE,
  PUT_ROOM_REASSIGN_REQUEST,
  PUT_ROOM_REASSIGN_SUCCESS,
  RESET_BOOKING_SUCCESS,
  RESET_ROOM_BOOKING,
} from "../../../Utils/Constant";

const initialState = {
  roomReservation: {},
  addReservation: {},
  allReservation: {},
  updateReservation: {},
  roomReservationById: {},
  reassign: {},
  reservationExport: {},
  bookingLogs: {},
  updateBooking:{},
  recordPayment:{},
  loading: false,
  error: null,
  bookingSuccess: false,
  bookingFail: false,
};
// Get the list of room reservation
export const roomReservationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ROOM_BOOKING_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_ROOM_BOOKING_LIST_SUCCESS:
      return {
        ...state,
        roomReservation: action.payload.data,
        loading: false,
        error: null,
      };

    case GET_ROOM_BOOKING_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    //add room reservation
    case POST_ROOM_BOOKING_REQUEST:
      return {
        ...state,
        loading: true,
        bookingSuccess: false,
        error: null,
        bookingFail:false,
      };
    case POST_ROOM_BOOKING_SUCCESS:
      return {
        ...state,
        addReservation: action.payload,
        bookingSuccess: true,
        loading: false,
        bookingFail:false,
        error: null,
      };

    case POST_ROOM_BOOKING_FAILURE:
      return {
        ...state,
        loading: false,
        bookingSuccess: false,
        bookingFail:true,
        error: action.payload,
      };

    //reassing room
    case PUT_ROOM_REASSIGN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case PUT_ROOM_REASSIGN_SUCCESS:
      return {
        ...state,
        loading: false,
        reassign: action.payload,
        error: null,
      };
    case PUT_ROOM_REASSIGN_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // edit room booking
    case PATCH_ROOM_BOOKING_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        bookingSuccess: false,
      };
    case PATCH_ROOM_BOOKING_SUCCESS:
      return {
        ...state,
        updateBooking: action.payload,
        loading: false,
        bookingSuccess: true,
        error: null,
      };
    case PATCH_ROOM_BOOKING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        bookingSuccess: false,
        bookingFail: true,
      };

    //export room booking
    case EXPORT_ROOM_BOOKING_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case EXPORT_ROOM_BOOKING_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case EXPORT_ROOM_BOOKING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case RESET_ROOM_BOOKING:
      return {
        ...state,
        error: null,
      };
    default:
      return state;

    // BOOKING LOG REQUEST //
    case GET_ALL_BOOKING_LOGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_ALL_BOOKING_LOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        bookingLogs: action.payload.data,
        error: null,
      };

    case GET_ALL_BOOKING_LOGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case GET_RESERVATION_LIST_EXPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_RESERVATION_LIST_EXPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        reservationExport: action.payload.data,
        error: null,
      };

    case GET_RESERVATION_LIST_EXPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "RESET_RESERVATION_EXPORT":
      return {
        ...state,
        reservationExport: "",
      };

    //  Get All Reservation Details
    case GET_ALL_RESERVATION_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_ALL_RESERVATION_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        allReservation: action.payload.data,
        error: null,
      };
    case GET_ALL_RESERVATION_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    //  Update Reservation Details
    case PUT_ROOM_BOOKING_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case PUT_ROOM_BOOKING_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        updateReservation: action.payload.data,
        error: null,
      };
    case PUT_ROOM_BOOKING_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    // Get The Booking Details By Id
    case GET_BYID_ROOM_BOOKING_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_BYID_ROOM_BOOKING_SUCCESS:
      return {
        ...state,
        roomReservationById: action.payload.data,
        loading: false,
        error: null,
      };

    case GET_BYID_ROOM_BOOKING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case POST_RECORD_PAYMENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case POST_RECORD_PAYMENT_SUCCESS:
      return {
        ...state,
        recordPayment: action.payload,
        loading: false,
        error: null,
      };

    case POST_RECORD_PAYMENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
      case RESET_BOOKING_SUCCESS:
      return {
        ...state,
        bookingSuccess: false,
        bookingFail: false,
        error: null,
      };

  }
};
